module.exports = "img/flags/MW.ce384b7.png";